import { render, staticRenderFns } from "./Up.vue?vue&type=template&id=62ffba4c&scoped=true"
import script from "./Up.vue?vue&type=script&lang=js"
export * from "./Up.vue?vue&type=script&lang=js"
import style0 from "./Up.vue?vue&type=style&index=0&id=62ffba4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ffba4c",
  null
  
)

export default component.exports